import { render } from "./vendors.vue?vue&type=template&id=7158c59e"
import script from "./vendors.vue?vue&type=script&lang=js"
export * from "./vendors.vue?vue&type=script&lang=js"

import "./vendors.vue?vue&type=style&index=0&id=7158c59e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__